export { default } from './loaderImage'
